import React from 'react';
import './TopSmoke.css';
import TopSmokeParticle from './TopSmokeParticle/TopSmokeParticle';

const TopSmoke = props => {
  const { active, styleSmoke } = props;

  // set particles
  const particles = [];
  for (let i = 0; i < 25; i += 1) {
    particles.push(
      <TopSmokeParticle key={`ptc-${i}`} id={i} active={active} />
    );
  }

  return (
    <div
      id="top-day-smoke"
      style={styleSmoke}
      className={active ? 'active' : ''}
    >
      {particles}
    </div>
  );
};

export default TopSmoke;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/TopSmoke/TopSmoke.js